module.exports = __webpack_public_path__ + "static/media/extra_oral_left.1e88f1bd.png";